<h6 class="title">Sugeridos para esta pantalla:</h6>
<button mat-menu-item matTooltip="¿Cómo trabajar con Sugerencias?" (click)="openVideo('priceSuggestions')">
  <mat-icon>play_circle_outline</mat-icon>
  ¿Cómo trabajar con Sugerencias?
</button>
